import { ProductDurationType } from "@fitness-app/data-models/entities/Product";
import { type ProductClient } from "@fitness-app/data-models/entities/ProductClient";

import { getProductClientAccessEnd } from "./getProductClientAccessEnd";

/**
 * When does the access an add-on FOLLOWS end (TRE-2110)?
 *
 * `getProductClientAccessEnd` answers from the paid access period and returns
 * `null` for every free client before looking further — but a free product can
 * still be time-boxed by its `productDuration` (Klucz: 14 days), copied onto the
 * client row as `startAt`/`endAt`. For a source that is the horizon an add-on
 * has to end with; only a source with neither is really unlimited.
 */
export const getLinkedSourceAccessEnd = (source: ProductClient): number | null => {
  const fromAccessPeriod = getProductClientAccessEnd(source);

  if (fromAccessPeriod) {
    return fromAccessPeriod;
  }

  const duration = source.productDuration;

  if (
    duration &&
    (duration.type === ProductDurationType.LastsFor || duration.type === ProductDurationType.UntilDate) &&
    duration.endAt
  ) {
    return duration.endAt;
  }

  return null;
};
